export default () => ({
	legacy: false,
	fallbackLocale: "az",
	missingWarn: false,
	fallbackWarn: false
});
